var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-xl card-style outlined flat",attrs:{"flat":"","color":"#FFFFF"}},[_c('div',{staticClass:"content-wrapper"},[_c('v-list-item-content',[_c('div',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(this.body)}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }